import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addItem, delItem } from '../../redux/action';
import { sendRequest } from '../../ApiRequest';
import { BASE_URL } from '../../URL/constants';

const AddToCartButton = ({ product, quantity = 1, setQuantity }) => {
  const dispatch = useDispatch();
  const [cartBtn, setCartBtn] = useState("ADD TO CART");

  useEffect(() => {
		const updateCartBtn = async () => {
			const userDetails = JSON.parse(localStorage.getItem("userDetails"));

			if (userDetails?.data?.customer?.id) {
				try {
					const response = await sendRequest(
						'GET',
						`${BASE_URL}/v1/public_site/customers/${userDetails.data.customer.id}/cart`,
						null,
						{ Authorization: userDetails.data.token }
					);

					const data = response?.data || {};
					const cartItems = data?.cart_items || [];
					const isInCart = cartItems.some(cart => cart.item_id === product.id);
					setCartBtn(isInCart ? "REMOVE FROM CART" : "ADD TO CART");
				} catch (error) {
					console.error("Error fetching cart:", error);
				}

			} else {
				const cartState = JSON.parse(localStorage.getItem("cartState")) || {};
				setCartBtn(cartState[product.id] ? "REMOVE FROM CART" : "ADD TO CART");
			}
		};
		updateCartBtn();

		const handleStorage = (event) => {
			if (event.key === "cartState") {
				updateCartBtn();
			}
		};

		window.addEventListener("storage", handleStorage);
		return () => window.removeEventListener("storage", handleStorage);
	}, [product.id]);

  const handleCart = async () => {
    const currentUser = JSON.parse(localStorage.getItem("userDetails"));
    let cartState = JSON.parse(localStorage.getItem("cartState")) || {};
    let guestCartRaw = JSON.parse(localStorage.getItem("guestCart")) || [];
    
    // Handle both array and object formats of guestCart
    let guestCart;
    if (Array.isArray(guestCartRaw)) {
      guestCart = guestCartRaw;
    } else {
      guestCart = Object.values(guestCartRaw);
    }
    
    const isInCart = !!cartState[product.id];

    if (!currentUser || !currentUser.data || !currentUser.data.token || !currentUser.data.customer) {
      if (!isInCart) {
        const updatedCart = [...guestCart, { ...product, quantity }];
        // setQuantity(updatedCart.length)
        setCartBtn("ADD TO CART");
        localStorage.setItem("guestCart", JSON.stringify(updatedCart));
        dispatch(addItem({ ...product, quantity }));
        cartState[product.id] = true;
      } else {
        const updatedCart = guestCart.filter(item => item.id !== product.id && item.item_id !== product.id);
        // setQuantity(updatedCart.length);
        localStorage.setItem("guestCart", JSON.stringify(updatedCart));
        setCartBtn("REMOVE FROM CART");
        dispatch(delItem(product));
        delete cartState[product.id];
      }

      localStorage.setItem("cartState", JSON.stringify(cartState));
      setCartBtn(isInCart ? "ADD TO CART" : "REMOVE FROM CART");
      // Dispatch cart-updated event to update cart count immediately
      window.dispatchEvent(new Event('cart-updated'));
      return;
    }

    const token = currentUser.data.token;
    const customerId = currentUser.data.customer.id;

    if (!isInCart) {
      const cartData = {
        customer_id: customerId,
        item_id: product.id,
        quantity: quantity || 1
      };

      try {
        const response = await sendRequest(
          'POST',
          `${BASE_URL}/v1/public_site/customers/${customerId}/cart/cart_items`,
          cartData,
          { Authorization: token }
        );
        if (response?.data) {
          dispatch(addItem({ ...product }));
          cartState[product.id] = true;
          localStorage.setItem("cartState", JSON.stringify(cartState));
          // Dispatch cart-updated event to update cart count immediately
          window.dispatchEvent(new Event('cart-updated'));
          setCartBtn("REMOVE FROM CART");
        } else {
          console.error("Error adding to cart:", response?.message || "No response data");
        }
      } catch (err) {
        console.error("API error while adding to cart:", err);
      }

    } else {
      try {
        const response = await sendRequest(
          'DELETE',
          `${BASE_URL}/v1/public_site/customers/${customerId}/cart/cart_items/${product.id}`,
          null,
          { Authorization: token }
        );

        if (response?.data) {
          dispatch(delItem(product));
          delete cartState[product.id];
          localStorage.setItem("cartState", JSON.stringify(cartState));
          // Dispatch cart-updated event to update cart count immediately
          window.dispatchEvent(new Event('cart-updated'));
          setCartBtn("ADD TO CART");
        } else {
          console.error("Error removing from cart:", response?.message || "No response data");
        }
      } catch (err) {
        console.error("API error while removing from cart:", err);
      }
    }
  };

  return (
    <button className="add-to-cart-btn" onClick={handleCart}>
      {cartBtn}
    </button>
  );
};

export default AddToCartButton;
